import React, { useState } from 'react'
import ElementContainer from '../ElementContainer'
import {
  Box,
  Chip,
  Divider,
  Menu,
  MenuItem,
  Modal,
  Typography
} from '@mui/material'

import { dropDownSelectionStyles } from '../../../styles/classes/MobilePreviewClasses'
import { useTranslation } from 'react-i18next'
import customTheme from '../../../styles/mui_theme'
import { faCheck, faChevronDown } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import HighlightOffIcon from '@mui/icons-material/HighlightOff'

import { menuProps } from '../../../styles/mui_custom_theme'

const DropDownSelection = ({
  title,
  helpfulHint,
  multiCheck,
  itemOptions,
  onChangeValue,
  answer,
  isMandatory,
  disabled
}) => {
  const [modalOpen, setModalOpen] = useState()
  const [multiAnswer, setMultiAnswer] = useState(
    answer ?? itemOptions.map(() => null)
  )
  const [anchorEl, setAnchorEl] = React.useState(null)
  const open = Boolean(anchorEl)
  const { t } = useTranslation()
  const { classes } = dropDownSelectionStyles()

  const openCloseModalHanlder = () => {
    setModalOpen(prev => !prev)
  }

  const closeModalHandler = () => {
    onChangeValue(multiAnswer)
    setModalOpen(false)
  }

  const clickOptionHandlerMulti = index => {
    setMultiAnswer(prevValue => {
      const updatedArray = [...prevValue]
      if (updatedArray[index] === true) updatedArray[index] = null
      else updatedArray[index] = true
      return updatedArray
    })
  }

  const clickChipHandlerMulti = index => {
    setMultiAnswer(prevValue => {
      const updatedArray = [...prevValue]
      if (updatedArray[index] === true) updatedArray[index] = null
      else updatedArray[index] = true
      onChangeValue(updatedArray)
      return updatedArray
    })
  }

  const clickOptionHandlerSingle = index => {
    const updatedArray = itemOptions.map((_, idx) => {
      if (index === idx) return true
      else return null
    })
    setMultiAnswer(updatedArray)
    onChangeValue(updatedArray)
    handleClose()
  }

  const ListItem = ({ optionText, selected, index }) => {
    return (
      <div onClick={disabled ? () => {} : () => clickOptionHandlerMulti(index)}>
        <Box className={classes.listItemContainer}>
          <Typography className={classes.listItemText}>{optionText}</Typography>

          {selected && (
            <FontAwesomeIcon
              icon={faCheck}
              color={customTheme.colors.iconBlue}
            />
          )}
        </Box>
      </div>
    )
  }

  const handleClick = event => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }

  if (!multiCheck) {
    return (
      <ElementContainer title={title} helpfulHint={helpfulHint} isMandatory={isMandatory}>
        <Box className={classes.chipContainer}>
          {multiAnswer.findIndex(x => x === true) === -1 && (
            <Box className={classes.selectButtonAlt} onClick={disabled ? undefined : handleClick}>
              <Typography className={classes.selectButtonText}>
                {t('mobile_preview.select')}
              </Typography>
            </Box>
          )}
          {multiAnswer.findIndex(x => x === true) !== -1 && (
            <Box onClick={disabled ? undefined : handleClick} className={classes.optionPressable}>
              <Box
                className={classes.optionContainer}
              >
                <Typography className={classes.optionText}>
                  {itemOptions[multiAnswer.findIndex(x => x === true)]}
                </Typography>
                <FontAwesomeIcon
                  className={classes.optionIcon}
                  icon={faChevronDown}
                  color={customTheme.colors.iconBlue}
                />
              </Box>
            </Box>
          )}
          <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={menuProps}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center'
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'center'
            }}
          >
            {itemOptions.map((option, index) => {
              const selected = multiAnswer[index]
              return (
                <MenuItem
                  className={classes.menuItems}
                  sx={{ background: selected && customTheme.colors.lightBlue3 }}
                  key={`${option}-${index}`}
                  onClick={() => clickOptionHandlerSingle(index)}
                >
                  {option}
                </MenuItem>
              )
            })}
          </Menu>
        </Box>
      </ElementContainer>
    )
  }

  return (
    <ElementContainer
      title={title}
      helpfulHint={helpfulHint}
      isMandatory={isMandatory}
    >
      {multiAnswer.map((value, index) => {
        if (value) {
          return (
            <Chip
              variant="outlined"
              className={classes.selectedPill}
              size="small"
              key={`${value}-${index}`}
              label={itemOptions[index]}
              onClick={() => clickChipHandlerMulti(index)}
              onDelete={() => clickChipHandlerMulti(index)}
              deleteIcon={<HighlightOffIcon />}
            />
          )
        }
        return null
      })}

      <Box className={classes.chipContainer}>
        <Box
          className={classes.selectButtonAlt}
          onClick={openCloseModalHanlder}
        >
          <Typography className={classes.selectButtonText}>
            {t('mobile_preview.select')}
          </Typography>
        </Box>
      </Box>

      <Modal
        hideBackdrop
        open={modalOpen}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <Box sx={{ ...customTheme.dropDownPopUp }}>
          <Box className={classes.popUpContainer}>
            <Box className={classes.popUpHeader}>
              <Box className={classes.titleContainer}>
                <Typography className={classes.popUpHeaderTitle}>
                  {title}
                </Typography>
              </Box>

              <Divider className={classes.popUpDivider} />
              <Box className={classes.popUpList}>
                {itemOptions.map((option, index) => (
                  <ListItem
                    key={`${option}-${index}`}
                    optionText={option}
                    selected={multiAnswer[index]}
                    index={index}
                  />
                ))}
              </Box>
            </Box>
            <Box
              className={classes.popUpButtonContainer}
              onClick={closeModalHandler}
            >
              <Box className={classes.popUpButton}>
                <Typography className={classes.buttonText}>Done</Typography>
              </Box>
            </Box>
          </Box>
        </Box>
      </Modal>
    </ElementContainer>
  )
}

export default DropDownSelection
